/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('ext.animation', function (el) {
        Animations.create();
    });
    var AnimationNames;
    (function (AnimationNames) {
        AnimationNames["FadeIn"] = "fadeIn";
        AnimationNames["FadeInUp"] = "fadeInUp";
        AnimationNames["FadeInRight"] = "fadeInRight";
        AnimationNames["FadeInLeft"] = "fadeInLeft";
        AnimationNames["SlideInUp"] = "slideInUp";
    })(AnimationNames || (AnimationNames = {}));
    var DefaultAnimationDelay = {
        start: 0,
        interval: 100
    };
    var Animations = /** @class */ (function () {
        function Animations() {
            this.animationConfig = [];
            this.observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.4,
            };
        }
        Animations.create = function () {
            new Animations().run();
        };
        Animations.prototype.setObserverElementSelector = function (selector) {
            this.observerElementSelector = selector;
        };
        Animations.prototype.setObserverOptions = function (options) {
            this.observerOptions = options;
        };
        Animations.prototype.addAnimationConfig = function (config) {
            this.animationConfig = this.animationConfig.concat(config);
        };
        Animations.prototype.run = function () {
            if (this.isReduced()) {
                return;
            }
            if (this.disableInMobile()) {
                return;
            }
            this.dispatchEvents();
            this.initAnimation();
            this.initClassMapping();
            this.initObserver();
        };
        Animations.prototype.isReduced = function () {
            // @ts-ignore
            return window.matchMedia("(prefers-reduced-motion: reduce)") === true
                || window.matchMedia("(prefers-reduced-motion: reduce)").matches === true;
        };
        Animations.prototype.disableInMobile = function () {
            return document.body.clientWidth < 768;
        };
        Animations.prototype.dispatchEvents = function () {
            MoyaEventHandler.dispatch('ext.animations.init', {
                animations: this,
            });
        };
        Animations.prototype.initAnimation = function () {
            document.body.classList.add('hasAnimation');
        };
        Animations.prototype.initClassMapping = function () {
            this.animationConfig.forEach(function (item) {
                var elements = document.querySelectorAll(item.selector);
                if (elements) {
                    elements.forEach(function (element, i) {
                        element.classList.add('animation', 'animate-' + item.animation);
                        if (item.delay) {
                            element.style.animationDelay = (item.delay.start + item.delay.interval) * (i + 1) / 1000 + 's';
                        }
                    });
                }
            });
        };
        Animations.prototype.initObserver = function () {
            if (!this.observerElementSelector) {
                return;
            }
            function observerCallback(entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('hasEntered', 'inView');
                    }
                    else {
                        entry.target.classList.remove('inView');
                    }
                });
            }
            var observer = new IntersectionObserver(observerCallback, this.observerOptions);
            document.querySelectorAll(this.observerElementSelector).forEach(function (el) { return observer.observe(el); });
        };
        return Animations;
    }());

    MoyaEventHandler.on('ext.animations.init', function (e) {
        var animations = e.animations;
        animations.setObserverElementSelector('.frontpage #main > div');
        animations.addAnimationConfig([
            {
                selector: "#fpShortcuts ul li",
                animation: AnimationNames.FadeInUp,
                delay: DefaultAnimationDelay,
            },
            {
                selector: ".frontpage #main .box_newsheadlines li",
                animation: AnimationNames.FadeInUp,
                delay: DefaultAnimationDelay,
            },
            {
                selector: "#custom-banner ul li>a",
                animation: AnimationNames.FadeInUp,
            },
            {
                selector: "#custom-banner ul li .text",
                animation: AnimationNames.FadeInLeft,
            },
            {
                selector: "#custom-banner .owl-nav",
                animation: AnimationNames.FadeIn,
            },
            {
                selector: "#box_group_3col .wrap",
                animation: AnimationNames.FadeIn,
                delay: DefaultAnimationDelay,
            },
        ]);
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
